const SlidersIcon = ({
  height = 14,
  width = 16,
  color = "#fff",
}: {
  height?: number
  width?: number
  color?: string
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 14"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66667 0.333344C3.03486 0.333344 3.33333 0.63182 3.33333 1.00001V5.66668C3.33333 6.03487 3.03486 6.33334 2.66667 6.33334C2.29848 6.33334 2 6.03487 2 5.66668V1.00001C2 0.63182 2.29848 0.333344 2.66667 0.333344ZM8 0.333344C8.36819 0.333344 8.66667 0.63182 8.66667 1.00001V3.66668H10C10.3682 3.66668 10.6667 3.96515 10.6667 4.33334C10.6667 4.70153 10.3682 5.00001 10 5.00001H6C5.63181 5.00001 5.33333 4.70153 5.33333 4.33334C5.33333 3.96515 5.63181 3.66668 6 3.66668H7.33333V1.00001C7.33333 0.63182 7.63181 0.333344 8 0.333344ZM13.3333 0.333344C13.7015 0.333344 14 0.63182 14 1.00001V7.00001C14 7.3682 13.7015 7.66668 13.3333 7.66668C12.9651 7.66668 12.6667 7.3682 12.6667 7.00001V1.00001C12.6667 0.63182 12.9651 0.333344 13.3333 0.333344ZM8 6.33334C8.36819 6.33334 8.66667 6.63182 8.66667 7.00001V13C8.66667 13.3682 8.36819 13.6667 8 13.6667C7.63181 13.6667 7.33333 13.3682 7.33333 13V7.00001C7.33333 6.63182 7.63181 6.33334 8 6.33334ZM0 8.33334C0 7.96515 0.298477 7.66668 0.666667 7.66668H4.66667C5.03486 7.66668 5.33333 7.96515 5.33333 8.33334C5.33333 8.70153 5.03486 9.00001 4.66667 9.00001H3.33333V13C3.33333 13.3682 3.03486 13.6667 2.66667 13.6667C2.29848 13.6667 2 13.3682 2 13V9.00001H0.666667C0.298477 9.00001 0 8.70153 0 8.33334ZM10.6667 9.66668C10.6667 9.29849 10.9651 9.00001 11.3333 9.00001H15.3333C15.7015 9.00001 16 9.29849 16 9.66668C16 10.0349 15.7015 10.3333 15.3333 10.3333H14V13C14 13.3682 13.7015 13.6667 13.3333 13.6667C12.9651 13.6667 12.6667 13.3682 12.6667 13V10.3333H11.3333C10.9651 10.3333 10.6667 10.0349 10.6667 9.66668Z"
      />
    </svg>
  )
}

export default SlidersIcon
